<template>
  <div class="a4">
    <div style="font-weight: bold; text-align: center; margin-bottom: 10px;">{{ siteName }}</div>
    
    <div v-for="(row, i) in list" :key="i" style="border: 1px solid gray; border-radius: 5px; padding: 4px 0px; width: 100%;">

      <div style="font-weight: bold; margin: 1mm 4mm;">{{ row.category }}</div>

      <div v-for="(item, i) in row.items" :key="item.itemId" class="card" :class="i>0?'dot-border':''">

        <!-- 項目名 -->
        <div style="color: rgb(25 110 111); font-weight: bold;" >{{ item.item }}</div>

        <!-- 保存済み写真 -->
        <div v-if="item.photos && item.photos.length" class="photo-grid">
          <div v-for="(p, j) in item.photos" :key="item.itemId+'url'+j" class="photo-item">
            <img :src="p.s3Url" @load="onImageLoaded" class="photo">
          </div>
        </div>

        <!-- 備考 -->
        <div v-if="item.note" class="note">
          {{ item.note }}
        </div>
      </div>

    </div>
    <div id="loading" v-if="!loading"></div>
  </div>
</template>

<script>
import * as backend from '@libs/backend'
import * as utils from '@libs/utils'

export default {
  components: {
  },

  data() {
    return {
      loading: true,
      // データ
      list: [
        { category: '', open: true, items: [] }
      ],
      loadedCount: 0,
      totalCount: 0
    }
  },

  created() {
    this.getData()
  },

  methods: {
    /**
     * データ取得
     */
    async getData() {
      const res = await backend.postData('siteOutline/photoEdit', { siteCode: this.$route.query.siteCode, generatePDF: true })
      const list = res.data.data.list
      this.siteName = res.data.data.siteName

      this.totalCount = list.length

      this.setItem(list)
    },

    /**
     * データを画面表示の形に成形
     * @param list
     */
    setItem(list) {
      const map = new Map()

      for (const row of list) {
        if (!map.has(row.category)) {
          map.set(row.category, {
            category: row.category,
            open: false,
            items: []
          })
        }

        map.get(row.category).items.push(row)
      }

      this.list = [...map.values()]
    },

    /**
     * 画像が表示された件数をカウント
     */
    onImageLoaded() {
      this.loadedCount++

      // 全部の画像が表示されたらPDF生成開始
      if (this.loadedCount === this.totalCount) {
        utils.wait(1000)
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
@media print {
  @page {
    size: A4;
    margin: 6mm;
  }

  body {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}

.a4 {
  width: 210mm;
  min-height: 297mm;
  box-sizing: border-box;
  font-size: 14px;
  color: #333;
}

.card {
  /* border: 1px solid #4b7eb5; */
  /* border-radius: 4px; */
  /* padding: 6px; */
  padding: 4mm;

  break-inside: avoid;
  page-break-inside: avoid;
}

.dot-border {
  border-top: 1px dashed rgb(25 110 111);
}

.photo-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4mm;
  margin-top: 2mm;
}

.photo-item {
  width: 100%;
}

.photo {
  width: 100%;
  height: 45mm;      /* ←ここ重要（高さ固定） */
  object-fit: contain;
  border: 1px solid #ddd;
  border-radius: 2px;
}

.note {
  white-space: pre-line;
  /* font-size: 13px; */
  color: #424242;
  line-height: 1.6;
  margin-top: 2mm;
  margin-bottom: 2mm;
}
</style>